export const articlesFromOneData = (isUser = false) => ({
  analyticElementPrefix: 'ushp-getinspired',
  title: 'Get Inspired',
  articles: [
    ...isUser ? [{
      name: 'Recommended For You',
      articles: [
        {
          id: '21',
          title: 'Where to Stay, Play, and Eat in Chicago',
          body: "Chicago is ready to show you a good time, whether you're here for the arts, the food scene, or a family vacation.",
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/chicago-travel-guide/',
          analyticElement: 'user-where-to-stay-play-and-eat-in-chicago',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
          attribution: 'Recommended',
        },
        {
          id: '12',
          title: 'How to Make the Most of Your Trip to Las Vegas with American Express Travel®',
          body: 'Las Vegas thrills with neon lights, elaborate shows, and fine dining. Make the most of your next visit with our guide. ',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/las-vegas-travel-guide',
          analyticElement: 'user-how-to-make-the-most-of-your-trip-to-las-vegas-with-american-express-travel',
          imageUrl: 'https://www.americanexpress.com/en-us/travel/discover/photos/2838/19097/530/WLV_Beach_Club.jpg',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
          attribution: 'Recommended',
        },
        {
          id: '41',
          title: 'Make the Most of Your London Trip with American Express Travel®',
          body: 'Explore London with top tips on where to stay, what to do, and where to eat from local experts.',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/london-travel-guide/',
          analyticElement: 'user-make-the-most-of-your-london-trip-with-american-express-travel',
          imageUrl: 'https://www.americanexpress.com/en-us/travel/discover/photos/101668/15463/530/Rosewood London_Entrance_Wrought Iron Gates.jpg',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
          attribution: 'Recommended',
        },
        {
          id: '63',
          title: 'Maui Travel Guide',
          body: 'The Hawaiian Island of Maui charms with its balmy weather, invigorating waters, picture-perfect landscapes, and luxe resorts.',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/maui-travel-guide/',
          analyticElement: 'user-maui-travel-guide',
          imageUrl: 'https://www.americanexpress.com/en-us/travel/discover/photos/100283/85623/530/MAU_2414.jpg',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
          attribution: 'Recommended',
        },
      ],
    }] : [],
    {
      name: 'Guides',
      articles: [
        {
          id: '51',
          title: 'A Hawaiian Islands Guide for Every Type of Traveler',
          body: 'Explore our island-by-island guide to hotels, vacation rentals, activities, and cruises to find the right Hawaii getaway for you.',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/hawaii-getaways/',
          analyticElement: 'guest-a-hawaiian-islands-guide-for-every-type-of-traveler',
          imageUrl: 'https://www.americanexpress.com/en-us/travel/discover/photos/301051/125015/530/MNL_Lifestyle_SUP_Adults_01103_Fnl.jpg',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
        },
        {
          id: '52',
          title: 'How to Make the Most of Your Austin Trip',
          body: 'Live music and Formula 1® draw fans to sunny Austin, where you can also enjoy parks, barbecue, vintage shopping.',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/austin-travel-guide/',
          analyticElement: 'guest-how-to-make-the-most-of-your-austin-trip',
          imageUrl: 'https://www.americanexpress.com/en-us/travel/discover/photos/482772/96988/530/211129_129.jpg',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
        },
        {
          id: '69',
          title: 'Exploring Vancouver, From Misty Beaches to Wine Bars',
          body: 'This majestic city beckons with misty beaches, outdoor adventures, cozy wine bars, and award-winning restaurants.',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/exploring-vancouver/',
          analyticElement: 'guest-exploring-vancouver-from-misty-beaches-to-wine-bars',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
        },
        {
          analyticElement: 'getinspiredexploremore',
          ctaLabel: 'Explore All Inspiration',
          id: 'exploreMore',
          body: 'For more inspiration, explore our expert travel guides, itineraries, and curated hotels.',
          icon: 'guide',
          ctaDestination: 'https://www.americanexpress.com/travel/get-inspired',
        },
      ],
    },
    {
      name: 'Itineraries',
      articles: [
        {
          id: '81',
          title: '3 Days in Amsterdam: Canal Boat Rides, Culture, and Street Food',
          body: 'Hop aboard a canal boat ride, snack on stroopwafels, and explore museums and gardens in Amsterdam.',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/things-to-do-amsterdam-itinerary/',
          analyticElement: 'guest-3-days-in-amsterdam-canal-boat-rides-culture-and-street-food',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
        },
        {
          id: '9',
          title: '3 Days in Tokyo: Temples, Tasting Menus, and Immersive Digital Art',
          body: 'Tokyo is a fascinating mix of tradition and innovation, where you can explore temples, top dining, immersive digital art and more.',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/things-to-do-tokyo-itinerary',
          analyticElement: 'guest-3-days-in-tokyo-temples-tasting-menus-and-immersive-digital-art',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
        },
        {
          id: '11',
          title: '3 Days in Singapore: Vibrant Gardens, Street Food, and Multicultural Charm',
          body: 'Singapore blends culture, cuisine, and modernity. Discover top attractions and exclusive benefits with our Singapore guide. ',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/things-to-do-singapore-itinerary',
          analyticElement: 'guest-3-days-in-singapore-vibrant-gardens-street-food-and-multicultural-charm',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
        },
        {
          analyticElement: 'getinspiredexploremore',
          ctaLabel: 'Explore All Inspiration',
          id: 'exploreMore',
          body: 'For more inspiration, explore our expert travel guides, itineraries, and curated hotels.',
          icon: 'guide',
          ctaDestination: 'https://www.americanexpress.com/travel/get-inspired',
        },
      ],
    },
    {
      name: 'Articles',
      articles: [
        {
          id: '64',
          title: "16 Cool Hotel Pools That You Won't Want to Leave",
          body: 'Discover 16 spots to take a dip and unwind – made even better with benefits for eligible Card Members.',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/cool-hotel-pools/',
          analyticElement: 'guest-16-cool-hotel-pools-that-you-wont-want-to-leave',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
        },
        {
          id: '78',
          title: '14 Hotels with Exciting Ways to Use the $100 Credit',
          body: 'Horseback riding, stargazing excursions, and cooking classes are just a few of the eligible charges available.',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/ways-to-use-100-dollar-credit/',
          analyticElement: 'guest-14-hotels-with-exciting-ways-to-use-the-100-credit',
          imageUrl: 'https://www.americanexpress.com/en-us/travel/discover/photos/101649/18559/530/horses.jpg',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
        },
        {
          id: '7',
          title: 'These Hotel Restaurants Are Worth a Trip',
          body: 'Destination dining reaches new heights at these U.S. hotel restaurants with award-winning chefs and local flavors.',
          ctaDestination: 'https://www.americanexpress.com/en-us/travel/get-inspired/hotel-restaurants-destination-dining',
          analyticElement: 'guest-these-hotel-restaurants-are-worth-a-trip',
          imageUrl: 'https://www.americanexpress.com/en-us/travel/discover/photos/100652/16799/530/Le Sirenuse.jpg',
          fallbackImageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/crossSell/HotelFallback.png',
        },
        {
          analyticElement: 'getinspiredexploremore',
          ctaLabel: 'Explore All Inspiration',
          id: 'exploreMore',
          body: 'For more inspiration, explore our expert travel guides, itineraries, and curated hotels.',
          icon: 'guide',
          ctaDestination: 'https://www.americanexpress.com/travel/get-inspired',
        },
      ],
    },
  ],
});
